import values from 'object.values';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-map';
import 'raf/polyfill';

function polyfill() {
  if (!Object.values) {
    values.shim();
  }

  if (!Object.setPrototypeOf) {
    Object.setPrototypeOf = Object.setPrototypeOf || function (obj, proto) {
      // eslint-disable-next-line no-proto
      obj.__proto__ = proto;
      return obj;
    };
  }

  if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-extend-native
    String.prototype.startsWith = function (search, pos) {
      return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
  }

  if (!Object.entries) {
    Object.entries = function (obj) {
      const ownProps = Object.keys(obj);
      let i = ownProps.length;
      const resArray = new Array(i); // preallocate the Array
      while (i--) { resArray[i] = [ownProps[i], obj[ownProps[i]]]; }

      return resArray;
    };
  }
}

polyfill();



// WEBPACK FOOTER //
// ./src/polyfill.js